﻿package com.mgacreative.hotel.core.notifications.domain

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

class NotificationManager(
    private val channels: List<NotificationChannel>,
    private val prefsRepository: NotificationPreferencesRepository
) {
    
    suspend fun dispatch(userId: String, recipient: String, title: String, body: String, targetChannels: List<ChannelType>) {
        val prefs = prefsRepository.getPreferences(userId)
        
        targetChannels.forEach { channelType ->
            // Acceptance Criteria: Kullanıcı bir kanalı kapattığında o kanaldan bildirim gitmiyor
            val isEnabled = when (channelType) {
                ChannelType.PUSH -> prefs.pushEnabled
                ChannelType.EMAIL -> prefs.emailEnabled
                ChannelType.SMS -> prefs.smsEnabled
                ChannelType.WHATSAPP -> prefs.whatsappEnabled
            }
            
            if (isEnabled) {
                val channel = channels.find { it.type == channelType }
                channel?.let {
                    CoroutineScope(Dispatchers.Default).launch {
                        it.send(recipient, title, body)
                    }
                }
            }
        }
    }

    // Trigger: Yeni rezervasyon oluşturulduğunda misafire onay
    suspend fun notifyNewReservation(guestId: String, email: String, phone: String, resDetails: String) {
        dispatch(guestId, email, "Rezervasyon Onayı", resDetails, listOf(ChannelType.EMAIL, ChannelType.WHATSAPP))
    }

    // Trigger: Check-in/Check-out hatırlatması
    suspend fun notifyCheckInOutReminder(guestId: String, phone: String, isCheckIn: Boolean) {
        val title = if (isCheckIn) "Check-in Hatırlatması" else "Check-out Hatırlatması"
        dispatch(guestId, phone, title, "Otelimizde işlemlerinizi bekliyoruz.", listOf(ChannelType.SMS))
    }

    // Trigger: Bakım talebi oluşturulduğunda ilgili personele
    suspend fun notifyMaintenanceStaff(staffId: String, pushToken: String, taskDetails: String) {
        dispatch(staffId, pushToken, "Yeni Bakım Talebi", taskDetails, listOf(ChannelType.PUSH))
    }

    // Trigger: Ödeme alındığında makbuz
    suspend fun notifyPaymentReceipt(guestId: String, email: String, amount: String) {
        dispatch(guestId, email, "Ödeme Makbuzu", "Toplam: $amount ödendi.", listOf(ChannelType.EMAIL))
    }
}

